import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {ActionButton} from './ActionButton';
import {MenuItemIcon} from './MenuItemIcon';
import {Menu} from 'primereact/menu';
import $ from 'jquery';

export class MenuButtonComponent extends Component {
    constructor(props) {
        super(props);
        const items = props.items ? props.items : [];

        this.state = {
            items,
        };
        this.menuRef = React.createRef();
    }

    componentDidMount() {
        // eslint-disable-next-line no-undef
        $('a.p-menuitem-link').removeAttr('href');
    }

    onButtonClick(event) {
        if (event) {
            event.preventDefault();
        }
        this.menuRef.current.toggle(event);
    }
    render() {
        const {items} = this.state;
        const {iconSvg, iconSize} = this.props;
        return (
            <React.Fragment>
                <Menu model={items} popup ref={this.menuRef} appendTo={document.body} />
                {this.props.iconSvg ? (
                    <MenuItemIcon
                        alt={this.props.label ? this.props.label : ''}
                        className={`icon-svg ${iconSize}`}
                        iconSvg={iconSvg}
                        handleClick={this.onButtonClick.bind(this)}
                    />
                ) : (
                    <ActionButton
                        label={this.props.label ? this.props.label : 'Pobierz'}
                        iconName='mdi-download'
                        iconSide='left'
                        iconColor='white'
                        downloadFile
                        handleClick={this.onButtonClick.bind(this)}
                        rendered
                    />
                )}
            </React.Fragment>
        );
    }
}

MenuButtonComponent.defaultProps = {};

MenuButtonComponent.propTypes = {
    className: PropTypes.string,
};
